module.exports = __webpack_public_path__ + "img/4.ec2ab80c.jpg";